var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisualSearchClose = function SvgVisualSearchClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 6-8 8m8 0L6 6",
    stroke: "#fff",
    strokeLinecap: "round"
  })));
};
export { SvgVisualSearchClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjI1IiBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNCA2TDYgMTRNMTQgMTRMNiA2IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";